// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file[data-v-2e004e58] {\n  display: flex;\n  align-items: center;\n  min-width: 185px;\n  color: var(--v-white-base);\n}\n.file .file-status[data-v-2e004e58] {\n  bottom: 3px;\n  font-size: 10px;\n  text-align: right;\n  font-weight: normal;\n}", ""]);
// Exports
module.exports = exports;
